import { styled } from "@mui/material/styles";
import {
  Avatar as MuiAvatar,
} from "@mui/material";

export const AvatarContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const CustomAvatar = styled(MuiAvatar)(({ theme }) => ({
  backgroundSize: "200% auto",
  color: theme.colors["neutral.950"],

  fontWeight: theme.fontWeights.medium,
  fontFamily: theme.fonts.outfit,

  ".MuiAvatar-fallback": {
    width: "60%",
    height: "60%",
  },
}));
